export default {
  API_BASE_URL: "https://api.dermaster.asia/graphql",
};
